import registry from "./components/registry";
import { StepEight, StepFive, StepFour, StepNine, StepOne, StepSeven, StepSix, StepThree, StepTwo } from "./components";

registry.register(1, StepOne);
registry.register(2, StepTwo);
registry.register(3, StepThree);
registry.register(4, StepFour);
registry.register(5, StepFive);
registry.register(6, StepSix);
registry.register(7, StepSeven);
registry.register(8, StepEight);
registry.register(9, StepNine);

export { default as PlanDetails } from "./PlanDetails";